export enum FieldMappingEnum {
  VehicleNumberOfKeys = 1,
  VehicleMOTStatus = 2,
  VehicleV5Status = 3,
  VehicleServiceHistory = 4,
  FinanceHouse = 5
}
